import GeneralUserModel from "./generaluser.model";
import MediaEntity from "./mediaEntity.model";
import { StockTagModel } from "./stocks.model";

export default class CommentsModel {
    _id: string | undefined;
    body: string | undefined;
    media: MediaEntity[] | undefined;
    userId: string | undefined;
    postId: string | undefined;
    sourceId: string | undefined;
    sourceType: string | undefined;
    // new added
    metaData: any[] = [];
    links: any[] = [];
    hashtags: string[] = [];
    userTags: GeneralUserModel[] = [];
    stockTags: StockTagModel[] = [];
    suggestions: any = {};

    constructor() { }
}